import { createMuiTheme } from 'material-ui/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: "'canada-type-gibson', europa, Helvetica, sans-serif",
  },
  palette: {
    primary: {
      light: '#40B4E5',
      main: '#0066ff',
      contrastText: '#fff',
    },
    secondary: {
      light: '#FEDB97',
      main: '#FF9700',
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiFormControl: {
      root: {
        position: 'relative',
        zIndex: 2
      }
    },
    MuiCardMedia: {
      root: {
        minHeight: '120px',
        borderRadius: '10px 10px 0 0',
        cursor: 'pointer'
      }
    },
    MuiCardContent: {
      root: {
        paddingLeft: '18px!important',
        paddingRight: '18px!important',
        fontSize: '14px',
        cursor: 'pointer',
        height: 'calc(100% - 29px)',
        '&:last-child': {
          paddingBottom: '13px'
        }
      }
    },
    MuiTypography: {
      headline: {
        fontSize: '1rem',
        lineHeight: '1.2em',
        fontWeight: 600
      },
      subheading: {
        fontSize: '1rem',
        lineHeight: '1.2em',
        fontWeight: 300
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 102, 255, 0.7)'
      }
    },
    MuiSnackbar: {
      root: {
        zIndex: 350
      }
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#FF9700',
        fontWeight: 'bold',
        padding: '6px 25px 6px 30px'
      }
    },
    MuiRadio: {
      root: {
        color: '#0066ff'
      }
    },
    MuiFormGroup: {
      root: {
        flexWrap: 'nowrap'
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      },
      elevation3: {
        boxShadow: '0px 4px 7px 0 rgba(0,0,0,.2)'
      }
    },
    MuiTabs: {
      root: {
        minHeight: '40px'
      }
    },
    MuiTab: {
      root: {
        fontFamily: "'canada-type-gibson', europa, Helvetica, sans-serif",
        textTransform: 'none',
        height: '40px',
        margin: '0 5px'
      },
      textColorPrimary: {
        '&:hover': {
          color: '#0066ff'
        }
      },
      labelIcon: {
        height: '40px'
      },
      labelContainer: {
        paddingLeft: '10px!important',
        paddingRight: '10px!important'
      },
      label: {
        fontSize: '0.95rem!important'
      }
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(254,219,151,1)',
        padding: '4px 8px'
      },
      head: {
        fontSize: '1rem'
      }
    },
    MuiTablePagination: {
      select: {
        paddingRight: 20
      }
    },
    MuiInput: {
      underline: {
        '&:before': {
          height: 0
        },
        '&:after': {
          height: 0
        },
        '&:hover:not($disabled):before': {
          height: 0
        }
      },
      focused: {
        // boxShadow: '0px 0 5px 0px rgba(0, 0, 0, 0.2), 0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 0px 1px -2px rgba(0, 0, 0, 0.12)'
      }
    },
    MuiListItem: {
      root: {
        alignItems: 'flex-start'
      }
    }
  }
});

export default theme;


// WEBPACK FOOTER //
// ./src/muiTheme.js